module.exports = __webpack_public_path__ + "img/76344.7f2f436d.svg";